import React, { useContext } from "react";
import Image from "components/image";
import SocialMedia from "components/link-types/social";
import Link from "helpers/link";
import Accordion from "components/accordion";
import { AccountContext } from "context/account";
import { ReactComponent as ArrowDown } from "assets/svgs/accordion-arrow.svg";

export const FooterSocial = ({ logo, social }) => (
    <div className="footer-item">
        { logo && (<Image image={logo?.image} className="w-32" to={logo?.image?.url} />) }
        { logo?.showSocialIcons && (
            <div className="social-icons">
                <SocialMedia data={social} />
            </div>
        ) }
    </div>
);

export const FooterLinks = ({ data }) => {
    const { account: { authenticated } } = useContext(AccountContext);

    const getLink = (url) => {
        if (url !== "/account") return url;

        if (authenticated) return "/account";
        return "/account/login";
    };

    return (
        data.map((groupLink) => (
            <Accordion key={groupLink?._key} heading={groupLink?.directLink?.title} className="footer-item py-2.5 px-4 lg:px-0 lg:py-0 lg:hidden block" arrowFill="white">
                <ul className="py-4 lg:py-0 mx-auto lg:mx-0 text-xs w-[70%] pb-1.5 pr-0 block leading-7">
                    {groupLink.imageLinkData?.map((item) => (
                        <li key={item?._key}>
                            <Link to={getLink(item.directLink.url)}>{ item?.directLink.title }</Link>
                        </li>
                    ))}
                </ul>
            </Accordion>
        ))
    );
};

export const DesktopFooterLinks = ({ data }) => {
    const { account: { authenticated } } = useContext(AccountContext);
    
    const getLink = (url) => {
        if (url !== "/account") return url;

        if (authenticated) return "/account";
        return "/account/login";
    };

    return (
        data.map((groupLink) => (
            <div key={groupLink.directLink.title} className="footer-item px-0 py-0 bg-inherit lg:block hidden">
                <div role="button" tabIndex={0} className="flex hover:cursor-pointer items-center justify-between w-full">
                    <span className="link-heading text-inherit py-1.5">
                        { groupLink.directLink.title }
                    </span>
                    <div className="w-3 h-3 flex transition-all duration-500">
                        <ArrowDown fill="white" />
                    </div>
                </div>
                <div className="transition-all duration-500 overflow-hidden max-h-full">
                    <ul className="py-0 mx-0 text-xs w-[70%] pb-1.5 pr-0 block leading-7">
                        {groupLink.imageLinkData.map((item) => (
                            <li key={item?._key}>
                                <Link to={getLink(item.directLink.url)}>{ item?.directLink.title }</Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        ))
    );
};
